import { render } from "./CollectionQualityChecksEdit.vue?vue&type=template&id=403278e5&scoped=true"
import script from "./CollectionQualityChecksEdit.vue?vue&type=script&lang=js"
export * from "./CollectionQualityChecksEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-403278e5"]])

export default __exports__